/* BirdieDash product page behaviour. Loaded once per page (guarded). */
(function () {
  if (window.__bdPdpLoaded) return;
  window.__bdPdpLoaded = true;

  /* ---------------- helpers ---------------- */
  function formatMoney(cents, format) {
    cents = Number(cents) || 0;
    format = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = format.match(re);
    var key = m ? m[1] : 'amount';
    function num(n, dec, th, dp) {
      var p = (n / 100).toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(dp);
    }
    var out;
    switch (key) {
      case 'amount_no_decimals': out = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = num(cents, 2, "'", '.'); break;
      default: out = num(cents, 2, ',', '.');
    }
    return format.replace(re, out);
  }

  function addToCart(items) {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        return j;
      });
    });
  }

  function openCart() {
    /* UpCart (installed on this store) */
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
    if (typeof window.upcartOpenCart === 'function') {
      try { window.upcartOpenCart(); return; } catch (e) {}
    }
    /* Theme cart drawer (Dawn-style) */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (s) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: null, sections: s });
        })
        .catch(function () { window.location.href = '/cart'; });
      return;
    }
    window.location.href = '/cart';
  }
  window.BDOpenCart = openCart;

  /* ---------------- main product ---------------- */
  function PDP(root) {
    this.root = root;
    this.sid = root.getAttribute('data-section');
    this.fmt = root.getAttribute('data-money-format');
    var j = root.querySelector('[data-bd-json]');
    try { this.data = JSON.parse(j.textContent); } catch (e) { return; }
    this.form = document.getElementById('bd-form-' + this.sid);
    this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    this.filterMedia = root.hasAttribute('data-filter-media');
    this.variant = this.findById(Number(root.getAttribute('data-variant')));
    this.items = [];
    this.initSet();
    this.initBundle();
    this.bind();
    this.update(false);
  }

  /* ---------- set builder ---------- */
  function parseTier(s) {
    var p = String(s || '').split(',').map(Number);
    return { buy: p[0] || 0, get: p[1] || 0, pct: p[2] || 0 };
  }

  /* Which covers a tier discounts: the cheapest ones, like checkout. On a price tie the
     discount goes to the most recently added row, so the bundle reads 2nd 50% off, 3rd free. */
  function allocate(entries, t) {
    var res = { total: 0, off: entries.map(function () { return 0; }) };
    var unit = t ? t.buy + t.get : 0;
    if (!t || !t.get || !unit || entries.length < unit) return res;
    var count = Math.floor(entries.length / unit) * t.get;
    var order = entries.map(function (e, i) { return i; }).sort(function (a, b) {
      var A = entries[a], B = entries[b];
      if (A.price !== B.price) return A.price - B.price;
      if (A.main !== B.main) return A.main ? 1 : -1;
      return B.ord - A.ord;
    });
    for (var k = 0; k < count; k++) {
      var i = order[k], d = entries[i].price - Math.round(entries[i].price * (100 - t.pct) / 100); /* checkout rounds the discounted price */
      res.off[i] = d; res.total += d;
    }
    return res;
  }

  /* offers don't combine: the bigger discount wins (ties go to the higher tier) */
  function bestDeal(S, entries) {
    var a1 = allocate(entries, S.t1), a2 = allocate(entries, S.t2);
    if (a2.total > 0 && a2.total >= a1.total) return { a: a2, t: S.t2, name: S.n2 };
    if (a1.total > 0) return { a: a1, t: S.t1, name: S.n1 };
    return { a: a1, t: null, name: '' };
  }

  PDP.prototype.initSet = function () {
    var box = this.root.querySelector('[data-bd-set]');
    if (!box) { this.set = null; return; }
    var d = this.data, ci = d.colorIndex, colors = [];
    if (ci >= 0) d.variants.forEach(function (v) { if (colors.indexOf(v.options[ci]) === -1) colors.push(v.options[ci]); });
    this.set = {
      box: box,
      rows: box.querySelector('.bd-set__rows'),
      state: {},
      colors: colors,
      perColor: box.getAttribute('data-colors') === 'true' && colors.length > 1,
      t1: parseTier(box.getAttribute('data-t1')),
      t2: parseTier(box.getAttribute('data-t2')),
      n1: box.getAttribute('data-t1-name') || '',
      n2: box.getAttribute('data-t2-name') || '',
      msgOne: box.getAttribute('data-msg-one') || '',
      msgTwo: box.getAttribute('data-msg-two') || '',
      msgSaved: box.getAttribute('data-msg-saved') || '',
      showMain: box.hasAttribute('data-show-main'),
      mainLabel: box.getAttribute('data-main-label') || '',
      tagFree: box.getAttribute('data-tag-free') || 'FREE',
      tagPct: box.getAttribute('data-tag-pct') || '[pct]% off',
      teaser: box.getAttribute('data-teaser') || ''
    };
    var self = this;
    box.addEventListener('change', function (e) {
      var cb = e.target.closest('input[type="checkbox"]');
      if (!cb) return;
      var st = self.set.state[cb.value];
      if (st) st.on = cb.checked;
      cb.closest('.bd-set__row').classList.toggle('is-on', cb.checked);
      self.updateTotals();
    });
    box.addEventListener('click', function (e) {
      var chip = e.target.closest('.bd-set__chip');
      if (!chip) return;
      e.preventDefault();
      var st = self.set.state[chip.getAttribute('data-size')];
      if (!st) return;
      st.color = chip.getAttribute('data-color');
      st.on = true;
      self.renderSet();
      self.updateTotals();
    });
  };

  /* ---------- bundle picker: pick a box (1, 2 or 3 covers) ---------- */
  PDP.prototype.initBundle = function () {
    var box = this.root.querySelector('[data-bd-bundle]');
    if (!box || this.data.sizeIndex < 0) { this.bundle = null; return; }
    var def = Number(box.getAttribute('data-default')) || 1;
    this.bundle = {
      box: box,
      qty: def,
      picks: [null, null],
      touched: [false, false],
      t1: parseTier(box.getAttribute('data-t1')),
      t2: parseTier(box.getAttribute('data-t2')),
      n1: '', n2: '',
      save: box.getAttribute('data-save') || '',
      saving: box.getAttribute('data-saving') || '',
      tagPct: box.getAttribute('data-tag-pct') || '[pct]% off',
      tagFree: box.getAttribute('data-tag-free') || 'FREE',
      labels: [box.getAttribute('data-pick-2') || '2nd cover', box.getAttribute('data-pick-3') || '3rd cover'],
      first: box.getAttribute('data-pick-1') || '1st cover',
      change: box.getAttribute('data-change') || '',
      done: box.getAttribute('data-done') || 'Done',
      ghost: box.getAttribute('data-ghost') || '',
      style: box.getAttribute('data-style') || 'dropdown',
      optNames: box.getAttribute('data-opt-names') || '',
      editing: false,
      celebrate: box.hasAttribute('data-celebrate'),
      built: 0
    };
    var self = this, B = this.bundle;
    box.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-bd-bsel')) {
        e.stopPropagation();
        var d = self.data, si = d.sizeIndex, ci = d.colorIndex;
        var k = Number(t.getAttribute('data-k')), kind = t.getAttribute('data-kind');
        if (k < 0) {
          /* the 1st cover is the page's own selection: drive the main picker */
          var oi = kind === 'color' ? ci : si;
          var fsx = self.root.querySelector('[data-bd-opt="' + oi + '"]');
          if (fsx) {
            var inp = Array.prototype.filter.call(fsx.querySelectorAll('input'), function (x) { return x.value === t.value; })[0];
            var sel = fsx.querySelector('select');
            if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
            else if (sel) { sel.value = t.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          }
          return;
        }
        var cur = self.findById(B.picks[k]) || self.variant;
        var m = self.pickFor(kind === 'size' ? t.value : cur.options[si], kind === 'color' ? t.value : (ci >= 0 ? cur.options[ci] : null));
        if (m) { B.picks[k] = m.id; B.touched[k] = true; }
        self.renderBundle(true);
        self.updateTotals();
        return;
      }
      if (t.type === 'radio') {
        var before = self.bundleDeal(B.qty).a.total;
        B.qty = Number(t.value) || 1;
        B.editing = false;
        self.renderBundle(true);
        self.updateTotals();
        if (B.celebrate && self.bundleDeal(B.qty).a.total > before) self.celebrate(t.closest('[data-bd-card]'));
      }
    });
    box.addEventListener('click', function (e) {
      var nx = e.target.closest('[data-bd-next]');
      if (nx) {
        e.preventDefault();
        var r = B.box.querySelector('[data-bd-card="' + nx.getAttribute('data-bd-next') + '"] input[type="radio"]');
        if (r) r.click();
        return;
      }
      var ed = e.target.closest('[data-bd-edit]');
      if (ed) {
        e.preventDefault();
        B.editing = !B.editing;
        self.renderBundle(true);
        var card = B.box.querySelector('[data-bd-card="' + B.qty + '"]');
        if (!B.editing && card && card.getBoundingClientRect().top < 0) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var opt = e.target.closest('[data-bd-tile]');
      if (!opt || opt.disabled) return;
      e.preventDefault();
      var k = Number(opt.getAttribute('data-k'));
      var cur = self.findById(B.picks[k]) || self.variant;
      var d = self.data, si = d.sizeIndex, ci = d.colorIndex;
      var size = opt.hasAttribute('data-size') ? opt.getAttribute('data-size') : cur.options[si];
      var color = opt.hasAttribute('data-color') ? opt.getAttribute('data-color') : (ci >= 0 ? cur.options[ci] : null);
      var m = self.pickFor(size, color);
      if (!m) return;
      B.picks[k] = m.id;
      B.touched[k] = true;
      self.renderBundle(true);
      self.updateTotals();
      var again = B.box.querySelector('[data-bd-tile][data-k="' + k + '"].is-on' + (opt.hasAttribute('data-color') ? '[data-color]' : '[data-size]'));
      if (again) again.focus({ preventScroll: true });
    });
  };

  /* default extra covers: the other sizes in the same colour, so box 3 starts as a full set */
  /* default extra covers: the other sizes in the same colour, so box 3 starts as a full set.
     A cover the shopper hasn't touched keeps its size (following the page's colour) unless
     that size is now taken by the 1st cover or another pick. */
  PDP.prototype.bundleDefaults = function () {
    var B = this.bundle, v = this.variant, d = this.data, self = this;
    if (!B || !v) return;
    var si = d.sizeIndex, ci = d.colorIndex, color = ci >= 0 ? v.options[ci] : null;
    var used = [v.options[si]];
    for (var k = 0; k < 2; k++) {
      var cur = self.findById(B.picks[k]);
      if (B.touched[k] && cur && cur.available) { used.push(cur.options[si]); continue; }
      var want = null;
      if (cur && used.indexOf(cur.options[si]) === -1) want = self.pickFor(cur.options[si], color);
      for (var i = 0; !want && i < d.sizes.length; i++) {
        if (used.indexOf(d.sizes[i]) === -1) want = self.pickFor(d.sizes[i], color);
      }
      want = want || v;
      B.picks[k] = want.id;
      used.push(want.options[si]);
    }
  };

  PDP.prototype.pickFor = function (size, color) {
    var d = this.data, ci = d.colorIndex, m = this.findSized(size, color);
    if (m && m.available) return m;
    if (ci >= 0) {
      for (var c = 0; c < d.variants.length; c++) {
        var x = d.variants[c];
        if (x.available && x.options[d.sizeIndex] === size) return x;
      }
    }
    return null;
  };

  PDP.prototype.bundleEntries = function (q) {
    var B = this.bundle, v = this.variant, self = this, entries = [];
    if (!B || !v || !v.available) return entries;
    entries.push({ price: v.price, main: true, ord: -1, id: v.id });
    B.picks.slice(0, Math.max(0, q - 1)).forEach(function (id, k) {
      var m = self.findById(id);
      if (m && m.available) entries.push({ price: m.price, main: false, ord: k, id: m.id });
    });
    return entries;
  };

  PDP.prototype.bundleDeal = function (q) {
    return bestDeal(this.bundle, this.bundleEntries(q));
  };

  PDP.prototype.renderBundle = function (rebuild) {
    var B = this.bundle, v = this.variant, fmt = this.fmt, self = this;
    if (!B || !v) return;
    var tag = function (t) { return t.pct >= 100 ? B.tagFree : B.tagPct.replace('[pct]', t.pct); };
    B.box.querySelectorAll('[data-bd-card]').forEach(function (card) {
      var q = Number(card.getAttribute('data-bd-card'));
      var entries = self.bundleEntries(q), deal = bestDeal(B, entries);
      var gross = entries.reduce(function (a, e) { return a + e.price; }, 0);
      var on = q === B.qty;
      card.classList.toggle('is-on', on);
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = on;
      card.querySelector('[data-bd-price]').innerHTML = '<b>' + formatMoney(gross - deal.a.total, fmt) + '</b>' +
        (deal.a.total ? '<s>' + formatMoney(gross, fmt) + '</s>' : '');
      var save = card.querySelector('[data-bd-save]');
      if (save) {
        save.textContent = deal.a.total && B.save ? B.save.replace('[amount]', formatMoney(deal.a.total, fmt)) : '';
        save.hidden = !save.textContent;
      }
      var picks = card.querySelector('[data-bd-picks]');
      if (!picks) return;
      picks.hidden = !on || (q === 1 && !B.ghost);
      if (picks.hidden) { picks.innerHTML = ''; return; }
      if (rebuild || !picks.children.length) {
        var d = self.data, si = d.sizeIndex, ci = d.colorIndex;
        var colors = [];
        if (ci >= 0) d.variants.forEach(function (x) { if (colors.indexOf(x.options[ci]) === -1) colors.push(x.options[ci]); });
        var name = function (x) { return x.options.join(' · '); };
        /* a variant without its own photo borrows one of the same size */
        var photo = function (x) {
          if (!x) return null;
          if (x.image) return x.image;
          for (var i = 0; i < d.variants.length; i++) if (d.variants[i].image && d.variants[i].options[si] === x.options[si]) return d.variants[i].image;
          return null;
        };
        var img = function (x, w) { var p = photo(x); return p ? '<img src="' + p + '" alt="" loading="lazy" width="' + w + '" height="' + w + '">' : ''; };
        var swatch = function (c) {
          var css = String(c).toLowerCase().replace(/\s+/g, '');
          return window.CSS && CSS.supports && CSS.supports('color', css) ? css : null;
        };
        var html = '';
        if (B.style !== 'photos') {
          var rowsHtml = '';
          var ordinal = [B.first].concat(B.labels);
          entries.forEach(function (e, i) {
            var x = self.findById(e.id) || v, off = deal.a.off[i] || 0;
            var k = e.main ? -1 : e.ord;
            var sizeSel = '<select data-bd-bsel data-k="' + k + '" data-kind="size" aria-label="' + escapeHtml(ordinal[i] || '') + ' size">';
            d.sizes.forEach(function (sz) {
              var ok = !!self.pickFor(sz, ci >= 0 ? x.options[ci] : null);
              sizeSel += '<option value="' + escapeHtml(sz) + '"' + (x.options[si] === sz ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + escapeHtml(sz) + (ok ? '' : ' (sold out)') + '</option>';
            });
            sizeSel += '</select>';
            var colSel = '';
            if (colors.length > 1) {
              colSel = '<select data-bd-bsel data-k="' + k + '" data-kind="color" aria-label="' + escapeHtml(ordinal[i] || '') + ' colour">';
              colors.forEach(function (c) {
                var cx = self.findSized(x.options[si], c), ok = !!(cx && cx.available);
                colSel += '<option value="' + escapeHtml(c) + '"' + (x.options[ci] === c ? ' selected' : '') + (ok ? '' : ' disabled') + '>' + escapeHtml(c) + (ok ? '' : ' (sold out)') + '</option>';
              });
              colSel += '</select>';
            }
            var stamp = off ? (deal.t.pct >= 100 ? B.tagFree : B.tagPct.replace('[pct]', deal.t.pct)) : '';
            rowsHtml += '<div class="bd-bundle__crow">' +
              '<span class="bd-bundle__cnum">' + escapeHtml(ordinal[i] || '') + '</span>' +
              '<span class="bd-bundle__cthumb">' + img(x, 96) +
              (stamp ? '<i class="bd-bundle__cstamp' + (deal.t.pct >= 100 ? ' is-free' : '') + '">' + escapeHtml(stamp) + '</i>' : '') + '</span>' +
              '<span class="bd-bundle__csels">' + (colSel || '') + sizeSel + '</span>' +
              '</div>';
          });
          picks.innerHTML = (B.optNames ? '<p class="bd-bundle__chd">' + escapeHtml(B.optNames) + '</p>' : '') +
            '<div class="bd-bundle__crows">' + rowsHtml + '</div>';
          return;
        }
        if (!B.editing) {
          /* the set at a glance: one photo per cover, the deal stamped on the one that gets it */
          html = '<div class="bd-bundle__set" style="--n:' + entries.length + '">';
          entries.forEach(function (e, i) {
            var x = self.findById(e.id) || v, off = deal.a.off[i] || 0;
            var stamp = off ? (deal.t.pct >= 100 ? B.tagFree : B.tagPct.replace('[pct]', deal.t.pct)) : '';
            html += (i ? '<span class="bd-bundle__plus" aria-hidden="true">+</span>' : '') +
              '<div class="bd-bundle__item">' +
              '<span class="bd-bundle__iimg">' + img(x, 160) +
              (stamp ? '<i class="bd-bundle__stamp' + (deal.t.pct >= 100 ? ' is-free' : '') + '">' + escapeHtml(stamp) + '</i>' : '') + '</span>' +
              '<span class="bd-bundle__iname">' + escapeHtml(x.options[si]) + '</span>' +
              (colors.length > 1 ? '<span class="bd-bundle__icol">' + escapeHtml(x.options[ci]) + '</span>' : '') +
              '</div>';
          });
          /* an empty spot for the next deal: tap it to move up a box */
          var nextCard = B.box.querySelector('[data-bd-card="' + (q + 1) + '"]');
          var nd = nextCard ? self.bundleDeal(q + 1) : null;
          if (B.ghost && nd && nd.t) {
            var nstamp = nd.t.pct >= 100 ? B.tagFree : B.tagPct.replace('[pct]', nd.t.pct);
            html += '<span class="bd-bundle__plus" aria-hidden="true">+</span>' +
              '<button type="button" class="bd-bundle__item is-ghost" data-bd-next="' + (q + 1) + '">' +
              '<span class="bd-bundle__iimg"><span class="bd-bundle__gplus" aria-hidden="true">+</span>' +
              '<i class="bd-bundle__stamp' + (nd.t.pct >= 100 ? ' is-free' : '') + '">' + escapeHtml(nstamp) + '</i></span>' +
              '<span class="bd-bundle__iname">' + escapeHtml(B.ghost) + '</span></button>';
          }
          html += '</div>';
          if (B.change && q > 1) html += '<button type="button" class="bd-btn-link bd-bundle__edit" data-bd-edit>' + escapeHtml(B.change) + '</button>';
          picks.innerHTML = html;
          return;
        }
        for (var k = 0; k < q - 1; k++) {
          var cur = self.findById(B.picks[k]) || v;
          html += '<div class="bd-bundle__pick"><div class="bd-bundle__pickhd">' +
            '<span class="bd-bundle__lbl">' + escapeHtml(B.labels[k] || '') + ': <b>' + escapeHtml(name(cur)) + '</b></span>' +
            '<i class="bd-bundle__tag" data-bd-tag="' + k + '" hidden></i></div>' +
            '<div class="bd-bundle__opts" role="group" aria-label="' + escapeHtml(B.labels[k] || '') + '">';
          d.sizes.forEach(function (sz) {
            var x = self.pickFor(sz, ci >= 0 ? cur.options[ci] : null);
            var on = cur.options[si] === sz;
            html += '<button type="button" class="bd-bundle__opt' + (on ? ' is-on' : '') + '" data-bd-tile data-k="' + k + '" data-size="' + escapeHtml(sz) + '"' +
              ' aria-pressed="' + on + '"' + (x ? '' : ' disabled') + '>' + (photo(x) ? '<span class="bd-bundle__oimg">' + img(x, 120) + '</span>' : '') + '<span class="bd-bundle__oname">' + escapeHtml(sz) + '</span></button>';
          });
          html += '</div>';
          if (colors.length > 1) {
            html += '<div class="bd-bundle__cols" role="group" aria-label="' + escapeHtml(B.labels[k] || '') + ' colour">';
            colors.forEach(function (c) {
              var x = self.findSized(cur.options[si], c);
              var on = cur.options[ci] === c;
              html += '<button type="button" class="bd-bundle__opt is-col' + (on ? ' is-on' : '') + '" data-bd-tile data-k="' + k + '" data-color="' + escapeHtml(c) + '"' +
                ' aria-pressed="' + on + '" title="' + escapeHtml(c) + '"' + (x && x.available ? '' : ' disabled') + '>' + (swatch(c) ? '<span class="bd-bundle__dot" style="background:' + swatch(c) + '"></span>' : '<span class="bd-bundle__oimg">' + img(x, 80) + '</span>') + '<span class="bd-bundle__oname">' + escapeHtml(c) + '</span></button>';
            });
            html += '</div>';
          }
          html += '</div>';
        }
        html += '<button type="button" class="bd-btn bd-bundle__done" data-bd-edit>' + escapeHtml(B.done || 'Done') + '</button>';
        picks.innerHTML = html;
      }
      /* which extra cover gets the deal, and what it becomes */
      picks.querySelectorAll('[data-bd-tag]').forEach(function (el) {
        var k = Number(el.getAttribute('data-bd-tag')), idx = -1;
        entries.forEach(function (e, i) { if (!e.main && e.ord === k) idx = i; });
        var off = idx > -1 ? deal.a.off[idx] : 0;
        el.hidden = !off;
        el.className = 'bd-bundle__tag' + (off && deal.t.pct >= 100 ? ' is-free' : '');
        el.textContent = off ? tag(deal.t) : '';
      });
    });
  };

  /* a small pop on the picked box and the savings line */
  PDP.prototype.celebrate = function (card) {
    if (!card || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop');
    var sv = this.root.querySelectorAll('[data-bd-savings]');
    sv.forEach(function (el) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); });
  };

  PDP.prototype.findSized = function (size, color) {
    var d = this.data, v = this.variant, si = d.sizeIndex, ci = d.colorIndex;
    for (var i = 0; i < d.variants.length; i++) {
      var x = d.variants[i], ok = x.options[si] === size;
      for (var k = 0; ok && k < x.options.length; k++) {
        if (k === si) continue;
        if (k === ci) { if (color != null && x.options[k] !== color) ok = false; }
        else if (v && x.options[k] !== v.options[k]) ok = false;
      }
      if (ok) return x;
    }
    return null;
  };

  PDP.prototype.renderSet = function () {
    var S = this.set, v = this.variant, d = this.data, self = this;
    if (!S || !v || d.sizeIndex < 0) return;
    var si = d.sizeIndex, ci = d.colorIndex, fmt = this.fmt, html = '';
    d.sizes.forEach(function (size) {
      if (size === v.options[si]) return;
      var st = S.state[size];
      if (!st) st = S.state[size] = { on: false, color: ci >= 0 ? v.options[ci] : null };
      if (!S.perColor && ci >= 0) st.color = v.options[ci];
      var m = self.findSized(size, st.color);
      if ((!m || !m.available) && ci >= 0) {
        for (var c = 0; c < S.colors.length; c++) {
          var alt = self.findSized(size, S.colors[c]);
          if (alt && alt.available) { m = alt; st.color = S.colors[c]; break; }
        }
      }
      var ok = !!(m && m.available);
      if (!ok) st.on = false;
      var chips = '';
      if (S.perColor && ok) {
        chips = '<span class="bd-set__sw">';
        S.colors.forEach(function (c) {
          var cv = self.findSized(size, c);
          chips += '<button type="button" class="bd-set__chip' + (c === st.color ? ' is-on' : '') + '" data-size="' + escapeHtml(size) + '" data-color="' + escapeHtml(c) + '" title="' + escapeHtml(c) + '" aria-label="' + escapeHtml(size + ' in ' + c) + '"' + (cv && cv.available ? '' : ' disabled') + '>' +
            (cv && cv.image ? '<img src="' + cv.image + '" alt="" loading="lazy" width="56" height="56">' : '') + '</button>';
        });
        chips += '</span>';
      }
      html += '<label class="bd-set__row' + (st.on ? ' is-on' : '') + '" data-size="' + escapeHtml(size) + '">' +
        '<input type="checkbox" value="' + escapeHtml(size) + '"' + (st.on ? ' checked' : '') + (ok ? '' : ' disabled') + '>' +
        '<span class="bd-set__img">' + (m && m.image ? '<img src="' + m.image + '" alt="" loading="lazy" width="88" height="88">' : '') + '</span>' +
        '<span class="bd-set__nm"><b>' + escapeHtml(size) + '</b><em>' + (ok ? (ci >= 0 ? escapeHtml(st.color) : '') : 'Sold out') + '</em></span>' +
        chips +
        '<span class="bd-set__pr">' + (m ? formatMoney(m.price, fmt) : '') + '</span>' +
        '</label>';
    });
    var others = html;
    if (others && S.showMain) {
      html = '<div class="bd-set__row is-main is-on" data-main>' +
        '<span class="bd-set__lock" aria-hidden="true"></span>' +
        '<span class="bd-set__img">' + (v.image ? '<img src="' + v.image + '" alt="" loading="lazy" width="88" height="88">' : '') + '</span>' +
        '<span class="bd-set__nm"><b>' + escapeHtml(v.options[si]) + '</b><em>' + escapeHtml([S.mainLabel, ci >= 0 ? v.options[ci] : ''].filter(Boolean).join(' · ')) + '</em></span>' +
        '<span class="bd-set__pr">' + formatMoney(v.price, fmt) + '</span>' +
        '</div>' + others;
    }
    S.rows.innerHTML = html;
    S.box.hidden = !others;
  };

  PDP.prototype.updateTotals = function () {
    var v = this.variant, S = this.set, fmt = this.fmt, sid = this.sid, root = this.root, self = this;
    var q = document.querySelector('input[name="quantity"][form="bd-form-' + sid + '"]');
    var qty = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    var items = [], entries = [], spare = [], mainItem = null;
    if (v && v.available) { mainItem = { id: v.id, quantity: qty }; for (var i = 0; i < qty; i++) entries.push({ price: v.price, main: true, ord: -1 }); }
    if (S && v) {
      this.data.sizes.forEach(function (size, idx) {
        var st = S.state[size];
        if (!st || size === v.options[self.data.sizeIndex]) return;
        var m = self.findSized(size, st.color);
        if (!m || !m.available) return;
        if (st.on) { items.push({ id: m.id, quantity: 1 }); entries.push({ price: m.price, main: false, ord: idx, size: size }); }
        else spare.push({ price: m.price, main: false, ord: 999, size: size });
      });
    }
    var B = this.bundle;
    if (B && v && v.available) {
      this.bundleEntries(B.qty).forEach(function (e) {
        if (e.main) return;
        items.push({ id: e.id, quantity: 1 });
        entries.push(e);
      });
    }
    /* Checkout gives a tie to the first-added line, so add the extra covers newest-first and the
       selected cover last: the discount then lands on the same cover the builder shows. */
    items.reverse();
    if (mainItem) items.push(mainItem);
    this.items = items;
    var n = entries.length;
    var gross = entries.reduce(function (a, e) { return a + e.price; }, 0);
    var T = S || B;
    var deal = T ? bestDeal(T, entries) : { a: { total: 0, off: [] }, t: null, name: '' };
    var disc = deal.a.total;
    var d2 = deal.t && deal.t === T.t2 ? disc : 0;
    if (B) this.renderBundle(false);
    var stickyNow = document.querySelector('[data-bd-sticky="' + sid + '"] [data-bd-price-now]');
    if (stickyNow && v && v.available) stickyNow.textContent = formatMoney(gross - disc, fmt);
    var offerName = deal.name;

    /* set builder rows: what each cover actually costs in this bundle */
    if (S && S.rows && v) {
      var tag = function (t) { return t.pct >= 100 ? S.tagFree : S.tagPct.replace('[pct]', t.pct); };
      var priceHtml = function (price, off, t, tease) {
        if (off > 0) return '<i class="bd-set__tag' + (t.pct >= 100 ? ' is-free' : '') + '">' + escapeHtml(tag(t)) + '</i>' +
          '<span class="bd-set__amt"><s>' + formatMoney(price, fmt) + '</s> <b>' + formatMoney(price - off, fmt) + '</b></span>';
        return (tease ? '<i class="bd-set__tag is-tease">' + escapeHtml(tease) + '</i>' : '') + '<span class="bd-set__amt">' + formatMoney(price, fmt) + '</span>';
      };
      var mainOff = 0;
      entries.forEach(function (e, i) { if (e.main) mainOff = Math.max(mainOff, deal.a.off[i]); });
      var mainRow = S.rows.querySelector('[data-main]');
      if (mainRow) {
        mainRow.classList.toggle('is-deal', mainOff > 0);
        mainRow.querySelector('.bd-set__pr').innerHTML = priceHtml(v.price, mainOff, deal.t, '');
      }
      S.rows.querySelectorAll('.bd-set__row[data-size]').forEach(function (row) {
        var size = row.getAttribute('data-size'), off = 0, idx = -1;
        entries.forEach(function (e, i) { if (e.size === size) idx = i; });
        var pr = row.querySelector('.bd-set__pr');
        if (idx > -1) {
          off = deal.a.off[idx];
          pr.innerHTML = priceHtml(entries[idx].price, off, deal.t, '');
        } else {
          var sp = spare.filter(function (x) { return x.size === size; })[0];
          if (!sp) return;
          var tease = '';
          if (S.teaser) {
            /* only tease when adding this cover really increases the saving */
            var test = entries.concat([sp]), nd = bestDeal(S, test);
            if (nd.t && nd.a.total > disc && nd.a.off[test.length - 1] > 0) tease = S.teaser.replace('[deal]', tag(nd.t));
          }
          pr.innerHTML = priceHtml(sp.price, 0, null, tease);
        }
        row.classList.toggle('is-deal', off > 0);
      });
    }

    /* buttons */
    document.querySelectorAll('[data-bd-buy="' + sid + '"]').forEach(function (b) {
      var label = b.querySelector('[data-bd-atc-label]') || b;
      var ok = v && v.available;
      b.disabled = !ok;
      if (!v) { label.textContent = b.getAttribute('data-unavailable') || 'Unavailable'; return; }
      if (!ok) { label.textContent = b.getAttribute('data-soldout') || 'Sold out'; return; }
      var base = n > 1 ? (b.getAttribute('data-atc-multi') || 'Add [count] to cart').replace('[count]', n) : (b.getAttribute('data-atc') || 'Add to cart');
      if (b.hasAttribute('data-show-price')) {
        label.innerHTML = escapeHtml(base) + ' <span class="bd-btn__sep">·</span> ' + formatMoney(gross - disc, fmt) +
          (disc ? ' <span class="bd-btn__was">' + formatMoney(gross, fmt) + '</span>' : '');
      } else {
        label.textContent = base;
      }
    });

    /* savings line */
    var tagIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7l8.3 8.3-8.7 8.7z"/><circle cx="8" cy="8" r="1.5"/></svg>';
    root.querySelectorAll('[data-bd-savings]').forEach(function (el) {
      if (B && !S) {
        var said = disc > 0 && v && v.available && B.saving ? B.saving.replace('[amount]', formatMoney(disc, fmt)) : '';
        el.classList.toggle('is-big', !!said);
        el.hidden = !said;
        el.innerHTML = said ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span>' + escapeHtml(said) + '</span>' : '';
        return;
      }
      if (!S || !v || !v.available) { el.innerHTML = ''; el.hidden = true; return; }
      var msg = '';
      if (disc > 0) {
        msg = '<b>' + escapeHtml(S.msgSaved.replace('[offer]', offerName).replace('[amount]', formatMoney(disc, fmt))) + '</b>';
        if (d2 === 0 && S.msgTwo && n < S.t2.buy + S.t2.get) msg += ' · ' + escapeHtml(S.msgTwo);
      } else if (n >= 1 && S.msgOne) {
        msg = escapeHtml(S.msgOne);
      }
      el.hidden = !msg;
      el.innerHTML = msg ? tagIcon + '<span>' + msg + '</span>' : '';
    });

    /* offer tiers light up */
    var tiers = root.querySelectorAll('[data-bd-tier]'), best = null, bestQ = 0;
    tiers.forEach(function (t) {
      var tq = Number(t.getAttribute('data-bd-tier')) || 0;
      if (tq && n >= tq && tq >= bestQ) { best = t; bestQ = tq; }
    });
    tiers.forEach(function (t) { t.classList.toggle('is-active', t === best); });

    /* offer ladder: fill to the highest unlocked step (offers don't stack, so earlier steps read as passed) */
    root.querySelectorAll('[data-bd-ladder]').forEach(function (lad) {
      var steps = Array.prototype.slice.call(lad.querySelectorAll('[data-bd-step]'));
      if (!steps.length) return;
      var have = Math.max(1, n);
      var active = 0;
      steps.forEach(function (s, i) { if (Number(s.getAttribute('data-bd-step')) <= have) active = i; });
      steps.forEach(function (s, i) {
        s.classList.toggle('is-past', i < active);
        s.classList.toggle('is-on', i === active);
        s.classList.toggle('is-next', i === active + 1);
        var dot = s.querySelector('.bd-ladder__dot');
        if (dot) dot.textContent = i === active && i > 0 ? '✓' : s.getAttribute('data-bd-step');
      });
      var fill = lad.querySelector('[data-bd-ladder-fill]');
      if (fill) fill.style.width = (active / steps.length * 100) + '%';
    });
  };

  PDP.prototype.findById = function (id) {
    var v = this.data.variants;
    for (var i = 0; i < v.length; i++) if (v[i].id === id) return v[i];
    return v[0];
  };

  PDP.prototype.selected = function () {
    var out = [];
    this.root.querySelectorAll('[data-bd-opt]').forEach(function (fs) {
      var i = Number(fs.getAttribute('data-bd-opt'));
      var c = fs.querySelector('input:checked');
      var s = fs.querySelector('select');
      out[i] = c ? c.value : (s ? s.value : null);
    });
    return out;
  };

  PDP.prototype.match = function (opts) {
    var v = this.data.variants;
    for (var i = 0; i < v.length; i++) {
      var ok = true;
      for (var k = 0; k < opts.length; k++) if (opts[k] != null && v[i].options[k] !== opts[k]) { ok = false; break; }
      if (ok) return v[i];
    }
    return null;
  };

  PDP.prototype.bind = function () {
    var self = this, root = this.root;

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-bd-opt]')) {
        var v = self.match(self.selected());
        self.variant = v;
        self.update(true);
      }
    });

    /* quantity */
    root.querySelectorAll('[data-bd-qty]').forEach(function (w) {
      var input = w.querySelector('input');
      w.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var n = Math.max(1, (parseInt(input.value, 10) || 1) + (b.hasAttribute('data-plus') ? 1 : -1));
        input.value = n;
        self.updateTotals();
      });
      input.addEventListener('input', function () { self.updateTotals(); });
    });

    /* add to cart */
    var buy = function (e) {
        if (e) e.preventDefault();
        if (!self.variant || !self.variant.available) return;
        self.updateTotals();
        var items = self.items.length ? self.items.map(function (it) { return { id: it.id, quantity: it.quantity }; }) : [{ id: self.variant.id, quantity: 1 }];
        var btns = document.querySelectorAll('[data-bd-buy="' + self.sid + '"]');
        btns.forEach(function (b) { b.classList.add('is-loading'); });
        self.error('');
        addToCart(items)
          .then(function () {
            /* reset ticked extras so a second tap doesn't re-add them */
            if (self.set) {
              Object.keys(self.set.state).forEach(function (k) { self.set.state[k].on = false; });
              self.renderSet();
              self.updateTotals();
            }
            openCart();
          })
          .catch(function (err) { self.error(err.message); })
          .finally(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
    };
    /* Buttons are type="button" so cart apps that hijack product-form submits (UpCart) can't
       swallow the extra set-builder items. Enter-key submits still route through buy(). */
    document.querySelectorAll('[data-bd-buy="' + this.sid + '"]').forEach(function (b) {
      b.addEventListener('click', buy);
    });
    if (this.form) this.form.addEventListener('submit', buy);

    /* mini "add" buttons (matching set / upsell) */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bd-add]');
      if (!b) return;
      e.preventDefault();
      var id = Number(b.getAttribute('data-bd-add'));
      if (!id) return;
      var label = b.textContent;
      b.classList.add('is-loading');
      addToCart([{ id: id, quantity: 1 }])
        .then(function () {
          var card = b.closest('.bd-mini__card');
          if (card) card.classList.add('is-added');
          b.textContent = b.getAttribute('data-added') || 'Added';
          openCart();
          setTimeout(function () { b.textContent = label; if (card) card.classList.remove('is-added'); }, 2500);
        })
        .catch(function (err) { self.error(err.message); })
        .finally(function () { b.classList.remove('is-loading'); });
    });

    /* gallery zoom */
    var dlg = root.querySelector('[data-bd-zoom-dialog]');
    if (dlg && typeof dlg.showModal === 'function') {
      var img = dlg.querySelector('img'), list = [], idx = 0;
      var show = function () { if (list[idx]) img.src = list[idx]; };
      root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-bd-zoom]');
        if (!t) return;
        list = Array.prototype.slice.call(root.querySelectorAll('.bd-media__item:not(.is-hidden) [data-bd-zoom]'))
          .sort(function (a, b) { return a.closest('.is-lead') ? -1 : b.closest('.is-lead') ? 1 : 0; })
          .map(function (x) { return x.getAttribute('data-bd-zoom'); });
        idx = Math.max(0, list.indexOf(t.getAttribute('data-bd-zoom')));
        show();
        dlg.showModal();
      });
      dlg.addEventListener('click', function (e) {
        if (e.target.closest('[data-close]') || e.target === dlg) dlg.close();
        else if (e.target.closest('[data-prev]')) { idx = (idx - 1 + list.length) % list.length; show(); }
        else if (e.target.closest('[data-next]')) { idx = (idx + 1) % list.length; show(); }
      });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { idx = (idx - 1 + list.length) % list.length; show(); }
        if (e.key === 'ArrowRight') { idx = (idx + 1) % list.length; show(); }
      });
    }

    /* mobile dots */
    this.media = root.querySelector('[data-bd-media]');
    this.dots = root.querySelector('[data-bd-dots]');
    if (this.media && this.dots) {
      var t;
      this.media.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { self.syncDots(); }, 60);
      }, { passive: true });
      this.dots.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var items = self.visibleItems();
        var it = items[Number(b.getAttribute('data-i'))];
        if (it) self.media.scrollTo({ left: it.offsetLeft - self.media.offsetLeft - 20, behavior: 'smooth' });
      });
    }

    /* sticky mobile bar */
    var bar = document.querySelector('[data-bd-sticky="' + this.sid + '"]');
    var atc = root.querySelector('[data-bd-atc]');
    if (bar && atc && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (en) {
        var e = en[0];
        if (e.isIntersecting) seen = true;
        bar.classList.toggle('is-on', !e.isIntersecting && (seen || e.boundingClientRect.top < 0));
      }).observe(atc);
    }
  };

  PDP.prototype.error = function (msg) {
    this.root.querySelectorAll('[data-bd-error]').forEach(function (el) {
      el.textContent = msg || '';
      el.hidden = !msg;
    });
  };

  PDP.prototype.visibleItems = function () {
    return Array.prototype.slice.call(this.media.querySelectorAll('.bd-media__item:not(.is-hidden)'))
      .sort(function (a, b) { return a.classList.contains('is-lead') ? -1 : b.classList.contains('is-lead') ? 1 : 0; });
  };

  PDP.prototype.syncDots = function () {
    if (!this.media || !this.dots) return;
    var items = this.visibleItems();
    if (this.dots.children.length !== items.length) {
      var h = '';
      for (var i = 0; i < items.length; i++) h += '<button type="button" data-i="' + i + '" aria-label="Image ' + (i + 1) + '"></button>';
      this.dots.innerHTML = items.length > 1 ? h : '';
    }
    var sl = this.media.scrollLeft, best = 0, bd = Infinity;
    items.forEach(function (it, i) {
      var d = Math.abs(it.offsetLeft - this.media.offsetLeft - 20 - sl);
      if (d < bd) { bd = d; best = i; }
    }, this);
    Array.prototype.forEach.call(this.dots.children, function (d, i) { d.classList.toggle('is-on', i === best); });
  };

  PDP.prototype.update = function (fromUser) {
    var v = this.variant, root = this.root, fmt = this.fmt, self = this;
    var sel = this.selected();

    /* labels */
    root.querySelectorAll('[data-bd-opt]').forEach(function (fs) {
      var i = Number(fs.getAttribute('data-bd-opt'));
      var l = fs.querySelector('[data-bd-opt-selected]');
      if (l) l.textContent = sel[i] || '';
      /* availability of each value given the other selections */
      fs.querySelectorAll('.bd-chip').forEach(function (c) {
        var input = c.querySelector('input');
        var o = sel.slice(); o[i] = input.value;
        var m = self.match(o);
        c.classList.toggle('is-unavail', !m || !m.available);
      });
    });

    /* price */
    root.querySelectorAll('[data-bd-price-now]').forEach(function (el) { el.textContent = v ? formatMoney(v.price, fmt) : ''; });
    root.querySelectorAll('[data-bd-price-was]').forEach(function (el) {
      var on = v && v.compare > v.price;
      el.hidden = !on;
      if (on) el.textContent = formatMoney(v.compare, fmt);
    });
    root.querySelectorAll('[data-bd-save]').forEach(function (el) {
      var on = v && v.compare > v.price;
      el.hidden = !on;
      if (on) {
        var pct = Math.round((v.compare - v.price) * 100 / v.compare);
        el.textContent = (el.getAttribute('data-tpl') || 'Save [percent]%')
          .replace('[percent]', pct).replace('[amount]', formatMoney(v.compare - v.price, fmt));
      }
    });
    var stickyPrice = document.querySelector('[data-bd-sticky="' + this.sid + '"] [data-bd-price-now]');
    if (stickyPrice && v) stickyPrice.textContent = formatMoney(v.price, fmt);

    /* form inputs */
    if (this.idInput && v) this.idInput.value = v.id;
    var pt = root.querySelector('[data-bd-pt-id]');
    if (pt && v && pt.value !== String(v.id)) {
      pt.value = v.id;
      pt.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* set builder rows, bundle boxes, button labels, savings, tiers */
    this.renderSet();
    if (this.bundle) { this.bundleDefaults(); this.renderBundle(true); }
    this.updateTotals();

    /* url */
    if (fromUser && v && root.hasAttribute('data-update-url')) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }

    /* gallery */
    if (this.media && v) {
      var needle = ',' + v.id + ',';
      var optTags = v.options.map(function (o) { return '|' + String(o).toLowerCase().replace(/ /g, '-') + '|'; });
      var leadId = v.media;
      if (!leadId) { var first = this.media.querySelector('.bd-media__item'); leadId = first ? Number(first.getAttribute('data-media-id')) : null; }
      this.media.querySelectorAll('.bd-media__item').forEach(function (li) {
        var vids = li.getAttribute('data-variants') || ',';
        var tags = li.getAttribute('data-tags');
        var hide = false;
        if (self.filterMedia) {
          if (vids !== ',') hide = vids.indexOf(needle) === -1;
          else if (tags) hide = !optTags.some(function (t) { return tags.indexOf(t) > -1; });
        }
        li.classList.toggle('is-hidden', hide);
        li.classList.toggle('is-lead', Number(li.getAttribute('data-media-id')) === leadId);
      });
      if (fromUser) {
        if (window.matchMedia('(max-width: 989px)').matches) this.media.scrollTo({ left: 0, behavior: 'smooth' });
        else {
          var lead = this.media.querySelector('.is-lead');
          if (lead && lead.getBoundingClientRect().top < 0) lead.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      this.syncDots();
    }

    /* swatch images follow the selected size */
    root.querySelectorAll('[data-bd-opt] .bd-swatch').forEach(function (c) {
      var fs = c.closest('[data-bd-opt]');
      var i = Number(fs.getAttribute('data-bd-opt'));
      var o = sel.slice(); o[i] = c.querySelector('input').value;
      var m = self.match(o);
      var im = c.querySelector('img');
      if (m && m.image && im) im.src = m.image;
    });

    /* matching set */
    this.renderMatching();

    root.dispatchEvent(new CustomEvent('bd:variant', { bubbles: true, detail: { variant: v } }));
  };

  PDP.prototype.renderMatching = function () {
    var box = this.root.querySelector('[data-bd-matching]');
    if (!box) return;
    var d = this.data, v = this.variant, fmt = this.fmt;
    var si = d.sizeIndex;
    if (si < 0 || !v) { box.hidden = true; return; }
    var max = Number(box.getAttribute('data-max')) || 3;
    var btn = box.getAttribute('data-btn') || 'Add';
    var added = box.getAttribute('data-added') || 'Added';
    var sizes = d.sizes, html = '', n = 0;
    for (var i = 0; i < sizes.length && n < max; i++) {
      if (sizes[i] === v.options[si]) continue;
      var o = v.options.slice(); o[si] = sizes[i];
      var m = this.match(o);
      if (!m || !m.available) continue;
      n++;
      html += '<div class="bd-mini__card">' +
        '<span class="bd-mini__img">' + (m.image ? '<img src="' + m.image + '" alt="" loading="lazy" width="200" height="200">' : '') + '</span>' +
        '<span class="bd-mini__t">' + escapeHtml(sizes[i]) + '</span>' +
        '<span class="bd-mini__p">' + formatMoney(m.price, fmt) + '</span>' +
        '<button type="button" class="bd-btn bd-btn--sm" data-bd-add="' + m.id + '" data-added="' + escapeHtml(added) + '">' + escapeHtml(btn) + '</button>' +
        '</div>';
    }
    var row = box.querySelector('.bd-mini__row');
    if (row) row.innerHTML = html;
    box.hidden = n === 0;
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- sliders with arrows ---------------- */
  function initArrows(scope) {
    scope.querySelectorAll('[data-bd-slider]').forEach(function (wrap) {
      if (wrap.__bd) return; wrap.__bd = true;
      var track = wrap.querySelector('[data-bd-track]');
      var prev = wrap.querySelector('[data-bd-prev]');
      var next = wrap.querySelector('[data-bd-next]');
      if (!track) return;
      var step = function () { return Math.max(200, track.clientWidth * 0.8); };
      var sync = function () {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------------- recommendations ---------------- */
  function initRecs(scope) {
    scope.querySelectorAll('[data-bd-recs]').forEach(function (el) {
      if (el.__bd) return; el.__bd = true;
      fetch(el.getAttribute('data-bd-recs'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-bd-recs-body]');
          var cur = el.querySelector('[data-bd-recs-body]');
          if (fresh && cur && fresh.querySelector('.bd-pc__card')) {
            cur.replaceWith(fresh);
            initArrows(el);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------------- UGC video play ---------------- */
  function initUgc(scope) {
    scope.querySelectorAll('.bd-ugc__play').forEach(function (b) {
      if (b.__bd) return; b.__bd = true;
      b.addEventListener('click', function () {
        var fig = b.closest('.bd-ugc__i');
        var vid = fig.querySelector('video');
        if (!vid) return;
        if (vid.paused) { vid.muted = false; vid.play(); fig.classList.add('is-playing'); }
        else { vid.pause(); fig.classList.remove('is-playing'); }
      });
    });
  }

  /* ---------------- delivery estimate ---------------- */
  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }

  function initShip(scope) {
    scope.querySelectorAll('[data-bd-ship]').forEach(function (el) {
      if (el.__bd) return; el.__bd = true;
      var now = new Date();
      var fDay, fShort;
      try {
        fDay = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        fShort = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
      } catch (e) { return; }
      var dispatchDays = Number(el.getAttribute('data-dispatch')) || 0;
      var min = Number(el.getAttribute('data-min')) || 0;
      var max = Math.max(min, Number(el.getAttribute('data-max')) || 0);
      var dispatch = dispatchDays ? fDay.format(addBusinessDays(now, dispatchDays)) : 'today';
      var start = fShort.format(addBusinessDays(now, min));
      var end = fShort.format(addBusinessDays(now, max));
      var l1 = el.querySelector('[data-bd-ship-1]'), l2 = el.querySelector('[data-bd-ship-2]');
      if (l1 && el.getAttribute('data-line1')) l1.textContent = el.getAttribute('data-line1').replace('[dispatch]', dispatch);
      if (l2 && el.getAttribute('data-line2')) l2.textContent = el.getAttribute('data-line2').replace('[start]', start).replace('[end]', end);
    });
  }

  /* hide the installments slot when Shop Pay Installments renders nothing */
  function initInstallments(scope) {
    scope.querySelectorAll('.bd-installments').forEach(function (el) {
      setTimeout(function () { if (el.offsetHeight < 4) el.hidden = true; }, 2500);
    });
  }

  /* ---------------- product tabs ---------------- */
  function initTabs(scope) {
    scope.querySelectorAll('[data-bd-tabs]').forEach(function (sec) {
      if (sec.__bd) return; sec.__bd = true;
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-bd-tab]');
        if (!b) return;
        var i = b.getAttribute('data-bd-tab');
        sec.querySelectorAll('[data-bd-tab]').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        sec.querySelectorAll('[data-bd-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-bd-panel') !== i; });
      });
    });
  }

  /* ---------------- collection filters + sort ---------------- */
  function initFilters(scope) {
    scope.querySelectorAll('[data-bd-filters]').forEach(function (form) {
      if (form.__bd) return; form.__bd = true;
      var send = function () {
        /* drop empty price inputs so the URL stays clean */
        form.querySelectorAll('input[type="number"]').forEach(function (i) { i.disabled = i.value === ''; });
        form.submit();
      };
      form.addEventListener('change', function (e) { if (e.target.hasAttribute('data-bd-autosubmit')) send(); });
      form.addEventListener('submit', function (e) { e.preventDefault(); send(); });
      /* one dropdown open at a time; close on outside click */
      var drops = form.querySelectorAll('[data-bd-drop]');
      drops.forEach(function (d) {
        d.addEventListener('toggle', function () { if (d.open) drops.forEach(function (o) { if (o !== d) o.open = false; }); });
      });
      document.addEventListener('click', function (e) { if (!e.target.closest('[data-bd-drop]')) drops.forEach(function (o) { o.open = false; }); });
    });
  }

  function init(scope) {
    scope = scope || document;
    initShip(scope);
    initTabs(scope);
    initFilters(scope);
    initInstallments(scope);
    scope.querySelectorAll('[data-bd-pdp]').forEach(function (el) {
      if (el.__bd) return;
      el.__bd = true;
      new PDP(el);
    });
    initArrows(scope);
    initRecs(scope);
    initUgc(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
